import type { QuestHealthDay } from "./types";

export function makeQuestHealthDay(
  overrides: Partial<QuestHealthDay> & { date: string },
): QuestHealthDay {
  return {
    date: overrides.date,
    activeZoneMinutes: overrides.activeZoneMinutes ?? {
      total: 0,
      fatBurn: 0,
      cardio: 0,
      peak: 0,
    },
    steps: overrides.steps ?? 0,
    distanceMeters: overrides.distanceMeters ?? 0,
    sleep:
      overrides.sleep === undefined
        ? {
            minutesAsleep: 420,
            minutesAwake: 30,
            minutesInSleepPeriod: 450,
            stages: { awake: 30, light: 260, deep: 80, rem: 80 },
          }
        : overrides.sleep,
  };
}

export const mockQuestHealthDays = {
  noActivity: makeQuestHealthDay({
    date: "2026-05-01",
    steps: 0,
    activeZoneMinutes: { total: 0, fatBurn: 0, cardio: 0, peak: 0 },
  }),
  lowSleepNormalMovement: makeQuestHealthDay({
    date: "2026-05-02",
    steps: 8_000,
    activeZoneMinutes: { total: 35, fatBurn: 30, cardio: 5, peak: 0 },
    sleep: {
      minutesAsleep: 260,
      minutesAwake: 40,
      minutesInSleepPeriod: 300,
      stages: { awake: 40, light: 180, deep: 45, rem: 35 },
    },
  }),
  highSleepHighActivity: makeQuestHealthDay({
    date: "2026-05-03",
    steps: 16_000,
    activeZoneMinutes: { total: 90, fatBurn: 70, cardio: 18, peak: 2 },
    sleep: {
      minutesAsleep: 500,
      minutesAwake: 35,
      minutesInSleepPeriod: 535,
      stages: { awake: 35, light: 300, deep: 100, rem: 100 },
    },
  }),
  milestoneUnlock: makeQuestHealthDay({
    date: "2026-05-04",
    steps: 22_000,
    activeZoneMinutes: { total: 110, fatBurn: 85, cardio: 20, peak: 5 },
  }),
  chestUnlock: makeQuestHealthDay({
    date: "2026-05-05",
    steps: 28_000,
    activeZoneMinutes: { total: 130, fatBurn: 95, cardio: 30, peak: 5 },
  }),
  completion: makeQuestHealthDay({
    date: "2026-05-06",
    steps: 35_000,
    activeZoneMinutes: { total: 160, fatBurn: 120, cardio: 35, peak: 5 },
  }),
  corrected: makeQuestHealthDay({
    date: "2026-05-03",
    steps: 18_000,
    activeZoneMinutes: { total: 95, fatBurn: 75, cardio: 18, peak: 2 },
  }),
};
